export default __webpack_public_path__ + "static/media/048-no-parking.fbf20d55.png";